import { AmountCode, EventTypes, EntityTypes } from 'typings/enums';

interface IAmountEventData {
    amountCode: AmountCode;
    amountCycleId: number;
    value: number;
}

export interface IAmountEvent {
    eventType: EventTypes;
    entityType: EntityTypes;
    employeeSourceId: string;
    data: IAmountEventData;
    metadata: EmployeeEventMetadata;
}

export const getAmountEvent = (
    employeeSourceId: string,
    amountCode: AmountCode,
    amountCycleId: number,
    amountValue: number,
    affectWorkflow: boolean): IAmountEvent => {
    return {
        eventType: EventTypes.UpdateAmountEvent,
        entityType: EntityTypes.EmployeeCycle,
        employeeSourceId,
        data: {
            amountCode,
            amountCycleId,
            value: amountValue
        },
        metadata: { affectWorkflow }
    } as IAmountEvent;
};